"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTextfieldState = exports.renderFieldValidation = exports.renderFieldDescription = exports.renderFieldLabel = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
require("@/components/common/input/semantics/textfield-label");
require("@/components/common/input/semantics/textfield-description");
require("@/components/common/input/semantics/textfield-validation");
const utils_1 = require("@/utils");
const renderFieldLabel = (forId, label, optional) => {
    if (!label)
        return lit_1.nothing;
    return (0, lit_1.html) `
    <mm-textfield-label for=${forId} ?optional=${optional}>${label}</mm-textfield-label>
  `;
};
exports.renderFieldLabel = renderFieldLabel;
const renderFieldDescription = (description, id) => {
    if (!description)
        return lit_1.nothing;
    return (0, lit_1.html) `
    <mm-textfield-description id=${(0, if_defined_js_1.ifDefined)(id)}>${description}</mm-textfield-description>
  `;
};
exports.renderFieldDescription = renderFieldDescription;
const renderFieldValidation = (id, text) => {
    if (!text)
        return lit_1.nothing;
    return (0, lit_1.html) `
    <mm-textfield-validation id=${id}>${text}</mm-textfield-validation>
  `;
};
exports.renderFieldValidation = renderFieldValidation;
/**
 * textfield·numberfield가 공유하는 필드 상태, input 값 동기화, 포커스 위임.
 * 컨트롤 영역(슬롯 구성, 증감 버튼 등)은 각 컴포넌트가 소유한다.
 */
const withTextfieldState = (Base) => {
    class TextfieldStateElement extends Base {
        constructor() {
            super(...arguments);
            this.value = '';
            this.name = '';
            this.placeholder = '';
            this.size = 'medium';
            this.optional = false;
            this.hiddenLabel = false;
            this.disabled = false;
            this.ariaInvalid = null;
            this.inputId = (0, utils_1.uniqueId)('input');
        }
        get describedBy() {
            return [
                this.description && `${this.inputId}-description`,
                this.validationText && `${this.inputId}-validation`,
            ]
                .filter(Boolean)
                .join(' ');
        }
        // 호스트는 포커스를 받지 않으므로 mm-input으로 넘긴다.
        focus(options) {
            this.input?.focus(options);
        }
        handleInput(event) {
            const target = event.target;
            this.value = target.value;
            (0, utils_1.emit)(this, 'input', { value: this.value });
        }
    }
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], TextfieldStateElement.prototype, "value", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], TextfieldStateElement.prototype, "name", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], TextfieldStateElement.prototype, "placeholder", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], TextfieldStateElement.prototype, "label", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String })
    ], TextfieldStateElement.prototype, "description", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String, attribute: 'validation-text' })
    ], TextfieldStateElement.prototype, "validationText", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String, reflect: true })
    ], TextfieldStateElement.prototype, "size", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean })
    ], TextfieldStateElement.prototype, "optional", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean, attribute: 'hidden-label', reflect: true })
    ], TextfieldStateElement.prototype, "hiddenLabel", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean, reflect: true })
    ], TextfieldStateElement.prototype, "disabled", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: String, attribute: 'aria-invalid' })
    ], TextfieldStateElement.prototype, "ariaInvalid", void 0);
    __decorate([
        (0, decorators_js_1.query)('mm-input')
    ], TextfieldStateElement.prototype, "input", void 0);
    return TextfieldStateElement;
};
exports.withTextfieldState = withTextfieldState;
//# sourceMappingURL=data:application/json;base64,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